module.exports = __webpack_public_path__ + "img/am-diabetes-logo.f325b09.png";